export const DASHBOARD_SECTION_PATH_REGEX = /^\/([^/?#]+)(?:\/([^/?#]+))?\/?$/
export const DASHBOARD_HOME_PATH_REGEX = /^\/?$/
export const DASHBOARD_COMMUNICATIONS_EMAIL_TEMPLATES_PATH_REGEX = /^\/communications\/email-templates\/?$/
export const DASHBOARD_SYSTEM_EMAIL_LOGS_PATH_REGEX = /^\/system\/email-logs\/?$/
export const DASHBOARD_ACCOUNT_HOME_PATH_REGEX = /^\/account\/?$/
export const DASHBOARD_ACCOUNT_PROFILE_PATH_REGEX = /^\/account\/profile\/?$/
export const DASHBOARD_ACCOUNT_SECURITY_PATH_REGEX = /^\/account\/security\/?$/
export const DASHBOARD_ACCOUNT_SESSIONS_PATH_REGEX = /^\/account\/sessions\/?$/
export const DASHBOARD_ACCOUNT_AUDIT_PATH_REGEX = /^\/account\/audit\/?$/
export const DASHBOARD_ACCOUNT_PRIVACY_PATH_REGEX = /^\/account\/privacy\/?$/
export const DASHBOARD_ACCOUNT_PREFERENCES_PATH_REGEX = /^\/account\/preferences\/?$/
export const DASHBOARD_ACCOUNT_TEAM_PATH_REGEX = /^\/account\/team\/?$/
export const DASHBOARD_ACCOUNT_TEAM_EDIT_PATH_REGEX = /^\/account\/team\/edit\/([^/?#]+)\/?$/
